import { render } from "./ArchivedEmployees.vue?vue&type=template&id=3e2d4ca0&scoped=true"
import script from "./ArchivedEmployees.vue?vue&type=script&lang=js"
export * from "./ArchivedEmployees.vue?vue&type=script&lang=js"

import "./ArchivedEmployees.vue?vue&type=style&index=0&id=3e2d4ca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2d4ca0"]])

export default __exports__